export enum FileFormats {
  abinitio = 'abinitio',
  snaplogic = 'snaplogic',
  informatica = 'informatica',
  datastage = 'datastage',
  hive = 'hive',
  alteryx = 'alteryx',
  informaticaCloud = 'iics'
}

export const FileFormatLabels: Record<FileFormats, string> = {
  [FileFormats.abinitio]: 'Ab Initio',
  [FileFormats.snaplogic]: 'SnapLogic',
  [FileFormats.informatica]: 'Informatica Powercenter',
  [FileFormats.informaticaCloud]: 'Informatica Intelligent Cloud Services',
  [FileFormats.datastage]: 'DataStage',
  [FileFormats.hive]: 'Hive',
  [FileFormats.alteryx]: 'Alteryx'
};
